/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
const React = require('react')

const { Provider } = require('react-redux')

const { ModalProvider } = require('./src/context/ModalContext')
const initStore = require('./src/redux').default
const footnoteState = require('./src/utils/footnoteState').default

const store = initStore()

// eslint-disable-next-line react/display-name,react/prop-types
exports.wrapRootElement = ({ element }) => (
  <Provider store={store}>
    <ModalProvider>{element}</ModalProvider>
  </Provider>
)

exports.onPreRouteUpdate = () => {
  footnoteState.reset()
}

/**
 * Hook to manually update the scroll position on the program quiz page
 * when the location state is set. This ensures that the user does not lose
 * their place in the page when navigating between nodes.
 * @param {*} param0
 */
exports.shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const { location } = routerProps
  const overrideRoutes = ['/program-quiz/', '/program-quiz']

  if (
    overrideRoutes.indexOf(location.pathname) >= 0 &&
    location.state != null
  ) {
    if (
      prevRouterProps &&
      prevRouterProps.location.pathname === location.pathname
    ) {
      const yOffset = window.pageYOffset
      window.scrollTo(0, yOffset)
      return false
    }
  }

  return true
}
